import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/team/avatar.png';
import Avatar from 'components/common/Avatar';
import { useAuth } from 'hooks/useAuth';
import AppContext from 'context/Context';
import { getTenantDetails } from 'utils/routeUtils';

const ProfileDropdown = () => {
  const tenantDetails = getTenantDetails();
  const { name, resource_access } = tenantDetails;
  const roles = resource_access?.mrv_api_auth_client?.roles || [];
  const initials = name
    .split(' ')
    .map(word => word[0].toUpperCase())
    .join('');
  const { setConfig } = useContext(AppContext);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const userLogout = () => {
    setConfig('navbarCollapsed', true);
    setConfig('showBurgerMenu', false);
    logout();
  };
  return (
    <Dropdown navbar={true} as="li" className="flex align-items-center">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 nav-link d-flex align-items-center justify-content-center"
      >
        <Avatar
          src={team3}
          className="m-auto d-none d-md-block"
          style={{ width: '37px', height: '37px' }}
        />
        <div
          className="d-block d-md-none"
          style={{
            width: '38px',
            height: '38px',
            borderRadius: '28px',
            background: '#bbcebf'
          }}
        ></div>
        <span
          className="ms-2 d-block d-md-none"
          style={{ position: 'absolute', right: '10px' }}
        >
          {initials}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item
            className="d-block d-md-none"
            style={{ borderBottom: '1px solid lightgray' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>{name}</span>
              <span style={{ fontSize: '11px' }}>Logged as {roles[0]}</span>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={userLogout} as={Link} to="">
            <span>Logout</span>
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
